// Version 1.0 - 2025-03-20

import $ from "jquery";
import Cookies from "js-cookie";

const SEARCHQUERYSTRING = ["q", "query", "p", "keywords"];
const COOKIENAME = "Referrer";

class ReferCookie {
    private createCookie(name: string, value: string, days: number) {
        let options: Cookies.CookieAttributes = {
            secure: true,
            sameSite: "Lax",
        };
        if (days) {
            options["expires"] = days;
        }
        Cookies.set(name, value, options);
    }

    // Get the referrer query string parameters if they exist
    private getReferParams(): URLSearchParams | null {
        const referrer = document.referrer;
        if (referrer) {
            const splitreferrer = referrer.split("?");
            if (splitreferrer.length > 1) {
                return new URLSearchParams(splitreferrer[1]);
            }
        }
        return null;
    }

    calculateSearchPhrase(urlParams: URLSearchParams): string | null {
        const len = SEARCHQUERYSTRING.length;
        for (var i = 0; i < len; i++) {
            const value = SEARCHQUERYSTRING[i];
            const searchquery = urlParams.get(value);
            if (searchquery) {
                return searchquery;
            }
        }
        return null;
    }

    checkGoogleAnalytics(urlParams: URLSearchParams): string | null {
        const utmsource = urlParams.get("utm_source");
        const utmmedium = urlParams.get("utm_medium");
        if (utmsource && utmmedium) {
            return this.calculateReferCookie(utmsource, utmmedium);
        }
        return null;
    }

    checkBingCpc(urlParams: URLSearchParams): string | null {
        const utmsource = urlParams.get("utm_source");
        if (utmsource && utmsource.toLowerCase() === "bing") {
            const searchphrase = urlParams.get("utm_term");
            if (searchphrase) {
                return this.calculateReferCookie("bing (cpc)", searchphrase);
            } else {
                return this.calculateReferCookie("bing (cpc)", "");
            }
        }
        return null;
    }

    getReferCookieValue(): string | null {
        const urlParams = new URLSearchParams(window.location.search);
        const bingphrase = this.checkBingCpc(urlParams);
        if (bingphrase) {
            return bingphrase;
        }
        const gaphrase = this.checkGoogleAnalytics(urlParams);
        if (gaphrase) {
            return gaphrase;
        }
        const referrer = this.getReferParams();
        if (!referrer) {
            return null;
        }
        // regular referrers
        let searchphrase = this.calculateSearchPhrase(referrer);
        const referrerarr = document.referrer.split("/");
        let host = referrerarr[2];
        if (urlParams.get("gclid")) {
            if (!searchphrase) {
                searchphrase = this.calculateSearchPhrase(urlParams);
            }
            host = "google (cpc)";
        } else if (urlParams.get("ysmwa")) {
            host = "yahoo (cpc)";
        }
        if (searchphrase) {
            return this.calculateReferCookie(host, searchphrase);
        } else {
            let page: string;
            if (referrerarr.length > 3) {
                page = referrerarr.slice(3).join("/");
            } else {
                page = "";
            }
            return this.calculateReferCookie(host, page);
        }
    }

    calculateReferCookie(source: string | null, searchphrase: string | null) {
        const today = new Date();
        let dd: number | string = today.getDate();
        let mm: number | string = today.getMonth() + 1; //January is 0!

        const yyyy = today.getFullYear();
        if (dd < 10) dd = `0${dd}`;
        if (mm < 10) mm = `0${mm}`;
        const todaytext = `${mm}/${dd}/${yyyy}`;
        return "!" + encodeURIComponent(source ?? "") + "&" +
            encodeURIComponent(searchphrase ?? "") + "&" +
            encodeURIComponent(todaytext);
    }

    saveReferCookie() {
        const refcook = Cookies.get(COOKIENAME);
        if (!refcook) {
            // calculate refercookie
            let refercookievalue = this.getReferCookieValue();
            if (!refercookievalue) {
                refercookievalue = this.calculateReferCookie("unknown", "");
            }
            if (refercookievalue) {
                this.createCookie(COOKIENAME, refercookievalue, 90);
            }
        }
    }
}

$(function () {
    const cook = new ReferCookie();
    cook.saveReferCookie();
});
